import { render, staticRenderFns } from "./FighterVideo.vue?vue&type=template&id=3e855c7c&scoped=true"
import script from "./FighterVideo.vue?vue&type=script&lang=js"
export * from "./FighterVideo.vue?vue&type=script&lang=js"
import style0 from "./FighterVideo.vue?vue&type=style&index=0&id=3e855c7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e855c7c",
  null
  
)

export default component.exports